import { Container, SectionDetail, SectionTitle } from "components";
import React from "react";

function OurVaults() {
  return (
    <section className="vaultSection relative py-[35px] laptop:py-[70px]">
      <Container className="z-10">
        <div className="max-w-[912px] mx-auto text-center">
          <SectionTitle title="Our Vaults" className="mb-3 md:mb-4" />
          <SectionDetail
            detail="We offer three distinct vaults, each catering to different types of tokens and providing unique farming rewards."
            className="!text-base text-dim/80"
          />
        </div>

        <div className="mt-10 md:mt-16 laptop:mt-[48px]">
          <div className="grid laptop:grid-cols-3 gap-4 md:gap-5 laptop:gap-7">
            <div className="col-span-1 h-full">
              <div className="vaultCard h-full p-5 laptop:p-8 rounded-3xl bg-primaryBlack">
                <div className="w-[80px] h-[80px] laptop:w-[124px] laptop:h-[124px] rounded-[20px] flex items-center justify-center icon text-primaryBlack *:max-w-[60%] *:max-h-[60%] laptop:*:max-w-[80%] laptop:*:max-h-[80%] mb-[70px] laptop:mb-[128px]">
                  <svg
                    width="42"
                    height="66"
                    viewBox="0 0 42 66"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0 35.9432C7.40022 39.7561 15.1222 43.7472 21.0863 46.8354L42 35.9432C34.4275 46.8576 28.118 55.9439 21.0863 66C14.0421 55.9661 6.26271 44.8944 0 35.9432ZM0.804342 32.9327L21.1092 22.4208L41.1497 32.8558L21.1206 43.3793L0.804342 32.9327ZM21.0863 19.0529L0 29.8225L20.9943 0L42 29.8894L21.0863 19.0529Z"
                      fill="currentColor"
                    />
                    <path
                      d="M21.0863 46.8354L42 35.9432C34.4274 46.8576 21.0863 66 21.0863 66V46.8354ZM21.1092 22.4208L41.1497 32.8558L21.1206 43.3793L21.1092 22.4208ZM21.0863 19.0529L20.9943 0L42 29.8894L21.0863 19.0529Z"
                      fill="currentColor"
                    />
                    <path
                      d="M0.804342 32.9327L21.1111 34.5497L41.1516 32.8661L21.1214 43.3904L0.804342 32.9327Z"
                      fill="currentColor"
                    />
                    <path
                      d="M21.1111 34.5497L41.1516 32.8661L21.1214 43.3904L21.1111 34.5497Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>

                <h3 className="text-primaryWhite text-xxl laptop:text-[40px] leading-6 laptop:leading-10 -tracking-12 font-bold mb-3 md:mb-5">
                  ERC20 Vault
                </h3>

                <ul className="space-y-3">
                  <li className="text-dim text-sm md:text-base font-medium">
                    <p>
                      <span className="text-green font-bold mr-2">Stake</span>
                      ERC20 tokens from various projects
                    </p>
                  </li>
                  <li className="text-dim text-sm md:text-base font-medium">
                    <p>
                      <span className="text-green font-bold mr-2">Earn</span>
                      Rewards in the form of the early-stage project tokens
                      launching on Vanar
                    </p>
                  </li>
                  <li className="text-dim text-sm md:text-base font-medium">
                    <p>
                      <span className="text-green font-bold mr-2">
                        Ideal For
                      </span>
                      Users who hold Ethereum-based tokens and wish to add
                      utility to their holdings
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-span-1 h-full">
              <div className="vaultCard h-full p-5 laptop:p-8 rounded-3xl bg-primaryBlack">
                <div className="w-[80px] h-[80px] laptop:w-[124px] laptop:h-[124px] rounded-[20px] flex items-center justify-center icon text-primaryBlack *:max-w-[60%] *:max-h-[60%] laptop:*:max-w-[80%] laptop:*:max-h-[80%] mb-[70px] laptop:mb-[128px]">
                  <svg
                    width="72"
                    height="62"
                    viewBox="0 0 72 62"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M44.9918 62L53.9883 46.493L26.9988 0H8.99649L0 15.4977H18.0117L44.9918 62ZM62.9942 30.9953L72 15.4977L62.9942 0H45.0012L36.0047 15.4977H53.9977L62.9942 30.9953Z"
                      fill="currentColor"
                    />
                    <path
                      d="M53.9977 15.4977L62.9942 0H45.0012L36.0047 15.4977H53.9977Z"
                      fill="currentColor"
                    />
                    <path
                      d="M18.0117 15.4977L26.9988 0H8.99649L0 15.4977H18.0117Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>

                <h3 className="text-primaryWhite text-xxl laptop:text-[40px] leading-6 laptop:leading-10 -tracking-12 font-bold mb-3 md:mb-5">
                  VANRY Vault
                </h3>

                <ul className="space-y-3">
                  <li className="text-dim text-sm md:text-base font-medium">
                    <p>
                      <span className="text-green font-bold mr-2">Stake</span>
                      VANRY tokens on the Vanar Mainnet
                    </p>
                  </li>
                  <li className="text-dim text-sm md:text-base font-medium">
                    <p>
                      <span className="text-green font-bold mr-2">Earn</span>
                      Higher rate rewards in the form of the early-stage project
                      tokens launching on Vanar
                    </p>
                  </li>
                  <li className="text-dim text-sm md:text-base font-medium">
                    <p>
                      <span className="text-green font-bold mr-2">
                        Ideal For
                      </span>
                      VANRY token holders who want to maximize value while
                      supporting the Vanar ecosystem
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-span-1 h-full">
              <div className="vaultCard h-full p-5 laptop:p-8 rounded-3xl bg-primaryBlack">
                <div className="w-[80px] h-[80px] laptop:w-[124px] laptop:h-[124px] rounded-[20px] flex items-center justify-center icon text-primaryBlack *:max-w-[60%] *:max-h-[60%] laptop:*:max-w-[80%] laptop:*:max-h-[80%] mb-[70px] laptop:mb-[128px]">
                  <svg
                    width="72"
                    height="80"
                    viewBox="0 0 72 80"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M40 45C40 47.2091 38.2091 49 36 49C33.7909 49 32 47.2091 32 45C32 42.7909 33.7909 41 36 41C38.2091 41 40 42.7909 40 45Z"
                      fill="currentColor"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M36 53.5C40.6944 53.5 44.5 49.6944 44.5 45C44.5 40.3056 40.6944 36.5 36 36.5C31.3056 36.5 27.5 40.3056 27.5 45C27.5 49.6944 31.3056 53.5 36 53.5ZM36 55C41.5228 55 46 50.5228 46 45C46 39.4772 41.5228 35 36 35C30.4772 35 26 39.4772 26 45C26 50.5228 30.4772 55 36 55Z"
                      fill="currentColor"
                    />
                    <path
                      d="M71.9901 74.391V14.0775C71.9901 13.8984 71.9902 13.7227 71.8992 13.5435C71.8083 12.9199 71.539 12.2963 71.2662 11.7623C69.4581 7.57624 64.7542 0.00344533 62.313 0.00344533L9.76845 0C6.69427 0 0.364001 10.8663 0.0909284 13.3606C-3.20375e-07 13.7155 0 14.0738 0 14.4286V74.4772C0 77.5056 2.53205 80 5.60623 80H66.5614C68.1003 80 69.5446 79.3764 70.5414 78.3083C71.5381 77.1507 72.0811 75.8139 71.9901 74.391ZM69.1851 77.0617C68.4612 77.7749 67.5588 78.2193 66.5621 78.2193H5.61048C3.52958 78.2193 1.81235 76.5277 1.81235 74.4777V14.4327C1.81235 12.3827 3.52958 10.691 5.61048 10.691H66.3839C68.4648 10.691 70.182 12.3827 70.182 14.4327V74.4812C70.273 75.3701 69.9091 76.3485 69.1851 77.0617Z"
                      fill="currentColor"
                    />
                    <path
                      d="M62.1311 16.7469H10.0413C8.86622 16.7469 7.86946 17.7254 7.86946 18.8864V24.4093C6.60339 24.4989 5.51925 25.5669 5.51925 26.9037V34.8314C5.51925 36.1681 6.60339 37.2363 7.86946 37.3258V51.1344C6.60339 51.224 5.51925 52.2921 5.51925 53.6288V61.5565C5.51925 62.8933 6.60339 63.9614 7.86946 64.0509V70.1974C7.86946 71.3551 8.86273 72.337 10.0413 72.337H62.1347C63.3098 72.337 64.3065 71.3585 64.3065 70.1974L64.303 18.886C64.303 17.7249 63.3062 16.7469 62.1311 16.7469ZM7.32762 34.8315V26.9038C7.32762 26.5489 7.68784 26.1906 8.05156 26.1906H9.49947C9.8597 26.1906 10.2234 26.5455 10.2234 26.9038V34.8315C10.2234 35.1863 9.8632 35.5447 9.49947 35.5447H8.05156C7.68784 35.5447 7.32762 35.1898 7.32762 34.8315ZM7.32762 61.5606V53.6329C7.32762 53.278 7.68784 52.9197 8.05156 52.9197H9.49947C9.8597 52.9197 10.2234 53.2746 10.2234 53.6329V61.5606C10.2234 61.9155 9.8632 62.2738 9.49947 62.2738H8.05156C7.68784 62.2738 7.32762 61.9155 7.32762 61.5606ZM62.4946 70.2015C62.4946 70.3806 62.3127 70.5564 62.1343 70.5564L10.041 70.5598C9.85917 70.5598 9.6808 70.3806 9.6808 70.2049V64.0584C10.9469 63.9688 12.031 62.9008 12.031 61.564V53.6363C12.031 52.2996 10.9469 51.2314 9.6808 51.1419L9.67731 37.3262C10.9434 37.2366 12.0275 36.1686 12.0275 34.8318V26.9041C12.0275 25.5674 10.9434 24.4993 9.67731 24.4097V18.8869C9.67731 18.7077 9.85916 18.532 10.0375 18.532H62.1308C62.3127 18.532 62.4911 18.7112 62.4911 18.8869L62.4946 70.2015Z"
                      fill="currentColor"
                    />
                  </svg>
                </div>

                <h3 className="text-primaryWhite text-xxl laptop:text-[40px] leading-6 laptop:leading-10 -tracking-12 font-bold mb-3 md:mb-5">
                  Pre-stakers Vault
                </h3>

                <ul className="space-y-3">
                  <li className="text-dim text-sm md:text-base font-medium">
                    <p>
                      <span className="text-green font-bold mr-2">Stake</span>
                      {/* Early participation tokens or specific tokens designated
                      by Vanar */}
                      Exclusive vault reserved for pre mainnet stakers of Vanry
                    </p>
                  </li>
                  <li className="text-dim text-sm md:text-base font-medium">
                    <p>
                      <span className="text-green font-bold mr-2">Earn</span>
                      Highest rate rewards in the form of the early-stage
                      project tokens launching on Vanar
                    </p>
                  </li>
                  <li className="text-dim text-sm md:text-base font-medium">
                    <p>
                      <span className="text-green font-bold mr-2">
                        Ideal For
                      </span>
                      Early adopters and those committed to staking
                      their tokens for extended periods to gain higher returns
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default OurVaults;
